import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';

import { ODataLinkedService } from 'app/model/linkedservice/odata.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.odata.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.OData_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.OData_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: ODataLinkedService.MODEL // Linked service redefined
        }
    }
})
export class ODataResourceDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
